/**
 * Utility functions for styleFields components
 *
 * Extracted from TextElement.tsx for reuse across all element types
 */

/**
 * Validate hex color format
 * Accepts: #RGB, #RRGGBB, #RRGGBBAA
 *
 * @param color - The color string to validate
 * @returns true if valid hex color format
 */
export const isValidHexColor = (color: string): boolean => {
  return /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/.test(color);
};
